import {
  LogApi,
  InpPerformanceReport,
  LcpPerformanceReport,
  NetworkPerformanceReport,
  TtfbPerformanceReport,
} from './types';
import { Context } from '../sdk/types';

const log: LogApi = {
  logUncaughtError(error: string) {
    if (this.logApi === undefined) {
      // Return if SDK has not been initialized.
      return;
    }

    this.logApi.logUncaughtError(error);
  },

  logUnhandledRejection(rejection: string) {
    if (this.logApi === undefined) {
      // Return if SDK has not been initialized.
      return;
    }

    this.logApi.logUnhandledRejection(rejection);
  },

  logLcpPerformance(lcpPerformanceReport: LcpPerformanceReport) {
    if (this.logApi === undefined) {
      // Return if SDK has not been initialized.
      return;
    }

    this.logApi.logLcpPerformance(lcpPerformanceReport);
  },

  logTtfbPerformance(ttfbPerformanceReport: TtfbPerformanceReport) {
    if (this.logApi === undefined) {
      // Return if SDK has not been initialized.
      return;
    }

    this.logApi.logTtfbPerformance(ttfbPerformanceReport);
  },

  logInpPerformance(inpPerformanceReport: InpPerformanceReport) {
    if (this.logApi === undefined) {
      // Return if SDK has not been initialized.
      return;
    }

    this.logApi.logInpPerformance(inpPerformanceReport);
  },

  logNetworkPerformance(networkPerformanceReport: NetworkPerformanceReport) {
    if (this.logApi === undefined) {
      // Return if SDK has not been initialized.
      return;
    }

    this.logApi.logNetworkPerformance(networkPerformanceReport);
  },

  logContext(context: Context) {
    if (this.logApi === undefined) {
      // Return if SDK has not been initialized.
      return;
    }

    this.logApi.logContext(context);
  },
};

export { log };

export { Rating } from './types';
export type {
  InpPerformanceReport,
  LcpPerformanceReport,
  TtfbPerformanceReport,
  LogApi,
} from './types';
